import { createApp } from 'vue'
import AiAssistant from './AiAssistant'

const el = '.nyk-component--ai-assistant'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((AiAssistantDOM) => {
            const props = {
                searchUrl: AiAssistantDOM.dataset.searchUrl,
                lang: AiAssistantDOM.dataset.lang,
                labels: AiAssistantDOM.dataset.labels ? JSON.parse(AiAssistantDOM.dataset.labels) : null,
                configs: AiAssistantDOM.dataset.configs ? JSON.parse(AiAssistantDOM.dataset.configs) : null,
            }
            const component = createApp(AiAssistant, props).use(Store)
            component.mount(AiAssistantDOM)
        })
    }
}